var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * CircleHalf component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconCircleHalf extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon cat-c-icon-bi-directional', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.12828 4.22183C6.13129 2.15893 8.84795 1 11.6806 1C11.8614 1 12.0349 1.07398 12.1627 1.20565C12.2906 1.33733 12.3624 1.51592 12.3624 1.70214V22.2979C12.3624 22.4841 12.2906 22.6627 12.1627 22.7943C12.0349 22.926 11.8614 23 11.6806 23C8.84795 23 6.13129 21.8411 4.12828 19.7782C2.12528 17.7153 1 14.9174 1 12C1 9.08262 2.12528 6.28473 4.12828 4.22183ZM16.1954 1.24181C15.8274 1.07824 15.4009 1.25415 15.2427 1.63471C15.0846 2.01527 15.2547 2.45637 15.6227 2.61993C16.326 2.93254 16.9892 3.33286 17.5958 3.81272L17.6114 3.82476C18.2225 4.28178 18.7795 4.80916 19.2706 5.39881C19.532 5.71266 19.99 5.74794 20.2935 5.47761C20.597 5.20728 20.6311 4.73371 20.3697 4.41986C19.8058 3.74283 19.1676 3.13836 18.4693 2.6152C17.7689 2.06209 17.0045 1.60141 16.1954 1.24181ZM20.2935 18.6075C20.597 18.8779 20.6311 19.3514 20.3697 19.6653C19.8057 20.3424 19.1674 20.9469 18.4691 21.4701C17.7684 22.0224 17.0048 22.4836 16.1954 22.8433C15.8274 23.0069 15.4009 22.831 15.2427 22.4504C15.0846 22.0698 15.2547 21.6287 15.6227 21.4652C16.3255 21.1529 16.9883 20.7521 17.5963 20.272L17.6114 20.2604C18.2225 19.8034 18.7795 19.276 19.2706 18.6863C19.532 18.3725 19.99 18.3372 20.2935 18.6075ZM22.7037 9.29318C22.6141 8.88947 22.2249 8.6374 21.8345 8.73015C21.4441 8.8229 21.2004 9.22535 21.2901 9.62906C21.6366 11.1891 21.6366 12.8101 21.2901 14.3701C21.2004 14.7738 21.4441 15.1763 21.8345 15.269C22.2249 15.3618 22.6141 15.1097 22.7037 14.706C23.0994 12.9249 23.0994 11.0742 22.7037 9.29318Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconCircleHalf.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconCircleHalf.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconCircleHalf.prototype, "size", void 0);
if (customElements.get('cat-icon-circle-half') === undefined) {
    customElements.define('cat-icon-circle-half', BlocksIconCircleHalf);
}
